exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__iframe___JVV0q{border:none;width:100%;height:800px}", "", {"version":3,"sources":["/./src/routes/SocialMediaReward/src/routes/SocialMediaReward/containers/index.scss"],"names":[],"mappings":"AACA,uBACE,YAAY,WACD,YACE,CACd","file":"index.scss","sourcesContent":["\n.iframe {\n  border: none;\n  width: 100%;\n  height: 800px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"iframe": "index__iframe___JVV0q"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?sourceMap!./src/routes/SocialMediaReward/containers/index.scss
// module id = 2674
// module chunks = 0